import PropTypes from 'prop-types'
import React from 'react'

import Loader from '@components/loader'

import AppleIcon from '../../../images/apple_icon.svg'
import FacebookIcon from '../../../images/facebook_icon.svg'
import GoogleIcon from '../../../images/google_icon.svg'

import {
  getButtonShape,
  shouldRenderFacebookIcon,
  shouldRenderGoogleIcon,
  shouldRenderAppleIcon,
  shouldNotRenderButton
} from './helpers'
import styles from './styles'

class SSOButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false
    }
    this.buttonRef = React.createRef()
    this.bindHandlers()
  }

  bindHandlers() {
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleFocus() {
    this.setState({ focused: true })
  }

  handleBlur() {
    this.setState({ focused: false })
  }

  handleClick() {
    this.buttonRef.current.blur()
    this.props.clickHandler()
  }

  renderIcon(style) {
    if (shouldRenderFacebookIcon(this.props)) {
      return this.renderFacebookIcon(style)
    }
    if (shouldRenderGoogleIcon(this.props)) return this.renderGoogleIcon(style)

    if (shouldRenderAppleIcon(this.props)) return this.renderAppleIcon(style)

    return null
  }

  renderFacebookIcon(style) {
    return (
      <FacebookIcon
        aria-hidden='true'
        style={style}
      />
    )
  }

  renderGoogleIcon(style) {
    return (
      <GoogleIcon
        aria-hidden='true'
        style={style}
      />
    )
  }

  renderAppleIcon(style) {
    return (
      <AppleIcon
        aria-hidden='true'
        style={style}
      />
    )
  }

  renderCircularButtonContent() {
    return this.renderIcon(styles.iconCircular)
  }

  renderRectangleButtonContent() {
    return (
      <span>
        {this.renderIcon(styles.icon)}
        {this.props.label}
      </span>
    )
  }

  renderContent() {
    const { loading, circular, type } = this.props
    const buttonShape = getButtonShape(this.props)
    if (loading) {
      return <Loader colour={styles.loader[buttonShape][type].colour} />
    }
    return circular
      ? this.renderCircularButtonContent()
      : this.renderRectangleButtonContent()
  }

  render() {
    const { type, label } = this.props
    const buttonShape = getButtonShape(this.props)
    if (shouldNotRenderButton(this.props, process.env.APPLE_SSO_ENABLED)) {
      return null
    }
    return (
      <button
        ref={this.buttonRef}
        style={{
          ...styles.button[buttonShape].base,
          ...styles.button[buttonShape][type],
          ...(this.state.focused && styles.button[buttonShape].focused)
        }}
        onClick={this.handleClick}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        aria-label={label}
      >
        {this.renderContent()}
      </button>
    )
  }
}

SSOButton.defaultProps = {
  loading: false,
  circular: true
}

SSOButton.propTypes = {
  loading: PropTypes.bool,
  clickHandler: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['Facebook', 'Google', 'Apple']),
  circular: PropTypes.bool,
  label: PropTypes.string.isRequired // use the label as an aria-label even if no text in button
}

export default SSOButton
